import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';


class ModalAlunoMateriasAcoes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      treinamento: this.props.treinamento,
      date_start: this.props.date_start,
      date_finish: this.props.date_finish,
      staff_id: this.props.staff_id,
      team_id: this.props.team_id,
      training_id: this.props.training_id,
      team_training_id: this.props.team_training_id,
      team_training_matter_staff_id: this.props.team_training_matter_staff_id,
      status: this.props.status,
    };
    //bind geral
    // handleChange e handleChangeSelect necessitam do bind nas tags
    this.aprovarAluno = this.aprovarAluno.bind(this);
    this.reprovarAluno = this.reprovarAluno.bind(this);
  }

  
  // Fetch salvando a edição
  aprovarAluno(event) {
    event.preventDefault();
    var datasave = {
      staff_id: this.state.staff_id,
      status: this.state.status,
      team_training_id: this.state.team_training_id,
      team_training_matter_staff_id: this.state.team_training_matter_staff_id,
      team_id: this.state.team_id,
      training_id: this.state.training_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/materia/aluno/aprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.loadData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  reprovarAluno(event) {
    var datasave = {
      staff_id: this.state.staff_id,
      status: this.state.status,
      team_training_id: this.state.team_training_id,
      team_training_matter_staff_id: this.state.team_training_matter_staff_id,
      team_id: this.state.team_id,
      training_id: this.state.training_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/materia/aluno/reprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.loadData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    if (this.props.status == 0) {
      return (
        <div className='btn-group'>
          <RequestApi ref={'request_api'} />
          <button onClick={this.aprovarAluno} className='btn btn-xs btn-success' alt='Aprovar aluno' title='Aprovar aluno'><i className="fa fa-fw fa-check"></i></button>
          <button onClick={this.reprovarAluno} className='disabled btn btn-xs btn-danger' alt='Reprovar aluno' title='Reprovar aluno'><i className="fa fa-fw fa-close"></i></button>
        </div>
      );    
    } else if (this.props.status == 1){
      return (
        <div className='btn-group'>
          <RequestApi ref={'request_api'} />
          <button onClick={this.aprovarAluno} className='disabled btn btn-xs btn-success' alt='Aprovar aluno' title='Aprovar aluno'><i className="fa fa-fw fa-check"></i></button>
          <button onClick={this.reprovarAluno} className='btn btn-xs btn-danger' alt='Reprovar aluno' title='Reprovar aluno'><i className="fa fa-fw fa-close"></i></button>
        </div>
      );     
    } else {
      return (
        <div className='btn-group'>
          <RequestApi ref={'request_api'} />
          <button onClick={this.aprovarAluno} className='btn btn-xs btn-success' alt='Aprovar aluno' title='Aprovar aluno'><i className="fa fa-fw fa-check"></i></button>
          <button onClick={this.reprovarAluno} className='btn btn-xs btn-danger' alt='Reprovar aluno' title='Reprovar aluno'><i className="fa fa-fw fa-close"></i></button>
        </div>
      );     
    }
  }
}

export default ModalAlunoMateriasAcoes;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/ModalAlunoMateriasAcoes.js